import type { Mission } from '../missions.ts'

export const dia: Mission = {
  id: "dia",
  name: "Defense Intelligence Agency",
  short: "DIA",
  call: "Defense Intelligence",
  kind: "subagency",
  parent: "dod",
  community: "intelligence",
  url: "https://www.dia.mil/",
  established: 1961,
  palette: {
    primary: "#0f2752",
    secondary: "#ce0f3e",
    accent: "#fcd213",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:Seal_of_the_U.S._Defense_Intelligence_Agency.svg",
  },
  motif: "torch",
  mission: {
    text: "Provide intelligence on foreign militaries to prevent and decisively win wars",
    url: "https://www.dia.mil/About/About-Us/",
  },
  fact: {
    text: "On February 6, 1963, DIA's John Hughes gave a televised briefing on the removal of the Soviet missiles from Cuba.",
    url: "https://www.dia.mil/About/About-Us/",
  },
  seal: {
    file: "public/seals/dia.png",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_U.S._Defense_Intelligence_Agency.svg",
  },
  identifier: {
    about: "https://www.dia.mil/About/About-Us/",
    accessibility: "https://www.dia.mil/About/DIA-508/",
    foia: "https://www.dia.mil/FOIA.aspx",
    noFear: "https://www.dia.mil/News-Features/No-FEAR/",
    oig: "https://diaoig.oversight.gov/",
  },
  media: {
    photos: [
      {
        file: "/media/dia-headquarters-expansion.jpg",
        small: "/media/dia-headquarters-expansion-sm.jpg",
        alt: "The DIA headquarters expansion, a long gray and glass office building with a tall dark stair tower, behind a grassy slope planted with young evergreens and a fountain.",
        title: "DIA headquarters expansion at the Defense Intelligence Analysis Center, October 12, 2012",
        creator: "Defense Intelligence Agency",
        source: "https://commons.wikimedia.org/wiki/File:Defense_Intelligence_Agency_headquarters_expansion.jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/dia-headquarters-aerial.jpg",
        small: "/media/dia-headquarters-aerial-sm.jpg",
        alt: "Aerial view across open fields to the white, stepped Defense Intelligence Agency headquarters building on Bolling Air Force Base, with wooded hills behind.",
        title: "Defense Intelligence Agency headquarters, Bolling Air Force Base, March 1, 1988",
        creator: "MSgt Ken Hammond, U.S. Air Force",
        source: "https://commons.wikimedia.org/wiki/File:Defense_Intelligence_Agency_headquarters,_Bolling_Air_Force_Base.JPEG",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
